import { Tabs } from "@/components/pieces/Tabs";
import { Tab } from "@/types/tabs";

interface DesktopViewTabsProps {
  tabs: Tab[];
  currentTab: Tab;
  onTabChange: (tab: Tab) => void;
}

export function DesktopViewTabs({
  tabs,
  currentTab,
  onTabChange,
}: DesktopViewTabsProps) {
  return (
    <Tabs
      tabs={tabs}
      tab={currentTab}
      onTabChange={onTabChange}
      style={{ boxShadow: "none", borderTop: "none" }}
    />
  );
}
